import { useSyncExternalStore } from 'react';

const COMPACT_QUERY = '(max-width: 767px), (max-width: 1023px) and (max-height: 500px)';
function subscribe(onChange: () => void) {
  const media = window.matchMedia?.(COMPACT_QUERY);
  media?.addEventListener('change', onChange);
  return () => media?.removeEventListener('change', onChange);
}
const getSnapshot = () => window.matchMedia?.(COMPACT_QUERY).matches ?? false;

/** Native details must be open on desktop; CSS cannot expose a closed disclosure reliably. */
export function useCompactStudyLayout() {
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
